import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import type { RestActivateInventoryCosting } from "@KassaroAB/shared/types/inventoryCostingSettings";
import {
  activateInventoryCostingApi,
  getInventoryCostingApi,
  getSerialIssuesApi,
} from "../api/inventoryCostingApi";

const inventoryCostingKey = (storeId: StoreId | null) => [
  "stores",
  storeId,
  "inventoryCosting",
];

export const useGetInventoryCostingQuery = (storeId: StoreId | null) =>
  useQuery({
    queryKey: inventoryCostingKey(storeId),
    queryFn: () => getInventoryCostingApi(storeId!),
    enabled: !!storeId,
  });

export const useGetSerialIssuesQuery = (storeId: StoreId | null) =>
  useQuery({
    queryKey: [...inventoryCostingKey(storeId), "serialIssues"],
    queryFn: () => getSerialIssuesApi(storeId!),
    enabled: !!storeId,
  });

export const useActivateInventoryCostingMutation = (
  storeId: StoreId | null,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: RestActivateInventoryCosting) =>
      activateInventoryCostingApi(storeId!, data),
    onSuccess: (result) => {
      queryClient.setQueryData(inventoryCostingKey(storeId), result);
      queryClient.invalidateQueries({ queryKey: ["stores", storeId] });
    },
  });
};
